module.exports = __webpack_public_path__ + "static/luzia-80bbe9f07da5104d7ee06d946b65c4b0.png";